import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-low-stock-sheet',
  template: `
    <div class="sheet-header">
      <h3>
        <mat-icon color="warn">warning_amber</mat-icon>
        Productos con Stock Bajo (≤ 3 unidades)
      </h3>
      <button mat-icon-button (click)="dismiss()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div *ngIf="data.products.length === 0" class="empty-state">
      <mat-icon color="primary">check_circle</mat-icon>
      <p>¡Todos los productos tienen stock suficiente!</p>
    </div>

    <mat-list *ngIf="data.products.length > 0" class="product-list">
      <mat-list-item *ngFor="let p of data.products" class="product-item">
        <mat-icon matListItemIcon [class.zero-stock]="p.stock <= 0">
          {{ p.stock <= 0 ? 'report' : 'warning' }}
        </mat-icon>
        <div matListItemTitle>{{ p.nombre }}</div>
        <div matListItemLine>
          Código: {{ p.codigo }} |
          Stock: <strong [class.zero-stock]="p.stock <= 0">{{ p.stock }}</strong>
          <span *ngIf="p.proveedor"> | Proveedor: {{ p.proveedor?.nombre || '—' }}</span>
        </div>
      </mat-list-item>
    </mat-list>

    <div class="sheet-actions" *ngIf="data.products.length > 0">
      <button mat-raised-button color="accent" (click)="descargarPdf()">
        <mat-icon>picture_as_pdf</mat-icon>
        Descargar PDF
      </button>
    </div>
  `,
  styles: [`
    .sheet-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 16px;
      h3 { display: flex; align-items: center; gap: 8px; margin: 0; }
    }
    .empty-state {
      text-align: center;
      padding: 24px;
      color: #4CAF50;
      mat-icon { font-size: 36px; height: 36px; width: 36px; display: block; margin: 0 auto 8px; }
    }
    .product-list { max-height: 50vh; overflow-y: auto; }
    .product-item { border-bottom: 1px solid #f5f5f5; }
    .zero-stock { color: #f44336 !important; }
    .sheet-actions { padding: 12px 16px; display: flex; justify-content: flex-end; }
  `]
})
export class LowStockSheetComponent {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { products: any[] },
    private sheetRef: MatBottomSheetRef<LowStockSheetComponent>
  ) {}

  dismiss(): void {
    this.sheetRef.dismiss();
  }

  descargarPdf(): void {
    const doc = new jsPDF({ orientation: 'portrait', unit: 'pt', format: 'a4' });
    doc.setFontSize(14);
    doc.text('Reporte de Stock Bajo', 40, 40);
    doc.setFontSize(10);
    doc.text(`Generado: ${new Date().toLocaleDateString('es-MX')}`, 40, 56);

    autoTable(doc, {
      startY: 70,
      head: [['Código', 'Nombre', 'Stock', 'Proveedor']],
      body: this.data.products.map(p => [
        p.codigo || '—',
        p.nombre,
        p.stock,
        p.proveedor?.nombre || '—'
      ]),
      theme: 'grid',
      headStyles: { fillColor: [244, 67, 54], textColor: 255 },
      columnStyles: { 2: { halign: 'center' } }
    });

    doc.save(`stock-bajo-${new Date().toISOString().split('T')[0]}.pdf`);
  }
}
